import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { delReminder,clearAll } from '../../actions';


import '../../stylesheets/reminder.css'

class ReminderList extends Component {
    // constructor(props){
    //     super(props);
    //     // this.state={
    //     //     text: ''
    //     // }
    // }

    componentDidMount() {
        window.$('[data-toggle="tooltip"]').tooltip();
      }
      
      componentDidUpdate() {
        window.$('[data-toggle="tooltip"]').tooltip();
      }

 del(id){
    //console.log('Deleting ID',id);
    this.props.delReminder(id);
 }

 clear(){
  this.props.clearAll();
 }

 delAllBtn(){
     return(
        <div 
        className='del-all-btn' 
        data-toggle="tooltip" 
        title="Delete all" 
        data-placement="right"
        onClick={()=>this.clear()}>
        <i className='fa fa-times-circle'></i>
        </div>
     )
 }
  render() {

    let reminders = this.props.reminders;
    //console.log('ReminderList',this.props);
    return (
      <div className='list'>
        <ul className='list-group col'>
            {(reminders.length>0) ? reminders.map(
                (reminder) => {
                    return(
                        <li className='list-group-item' key={reminder.id}>
                            <div className='list-item'>
                                <div>{reminder.text} </div>
                                <div><small><em>{moment(new Date(reminder.dueDate)).fromNow()} </em></small></div>
                            </div>
                            <div className='list-item del-btn' 
                            onClick={()=>this.del(reminder.id)}><i className='fa fa-trash-alt'></i></div>
                        </li>
                    )
                }
            ) : null
            }
        </ul>
        {(reminders.length>=2)? this.delAllBtn() : null}
      </div>
    )
  }
}


export default connect(null,{delReminder,clearAll})(ReminderList);


// WEBPACK FOOTER //
// ./src/components/reminder/ReminderList.jsx